var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20L27.5 15L22.5 10V13.75H16.175C15.75 9.875 13.35 6.6 10 4.9375C9.95 2.8875 8.3 1.25 6.25 1.25C4.175 1.25 2.5 2.925 2.5 5C2.5 7.075 4.175 8.75 6.25 8.75C7.4375 8.75 8.475 8.1875 9.1625 7.325C11.5375 8.625 13.25 10.9625 13.65 13.75H9.775C9.25 12.3 7.875 11.25 6.25 11.25C4.175 11.25 2.5 12.925 2.5 15C2.5 17.075 4.175 18.75 6.25 18.75C7.875 18.75 9.25 17.7 9.775 16.25H13.65C13.25 19.0375 11.5375 21.375 9.175 22.675C8.475 21.8125 7.4375 21.25 6.25 21.25C4.175 21.25 2.5 22.925 2.5 25C2.5 27.075 4.175 28.75 6.25 28.75C8.3 28.75 9.95 27.1125 9.9875 25.0625C13.3375 23.4 15.7375 20.125 16.1625 16.25H22.5V20Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/Media.6fb1842ccf5d85b6390f22c330d81e31.svg";
export { ForwardRef as ReactComponent };